import React, { Component } from 'react';

import MauritiusDetails from './MauritiusDetails';

class MauritiusDetailsContainer extends Component {
    render() {
        return (
            <MauritiusDetails />
        )
    }
}

export default MauritiusDetailsContainer;


// WEBPACK FOOTER //
// ./src/pages/details/mauritius/MauritiusDetailsContainer.jsx